import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import {environment} from '../../../../environments/environment';
import {CookieService} from 'ngx-cookie';
declare var DDP_ENV: any;

@Injectable({
  providedIn: 'root'
})
export class OrderServiceService {
  readonly baseURL = DDP_ENV.orderUrl;
  constructor(private _http: Http, private cookieService: CookieService) { }

  getAllOrders(page, status, size, regexPattern) {
    console.log('Inside get all orders');
    if (localStorage.getItem('clientId') === 'ELASTIC_CARE') {
      return this._http.get(this.baseURL + '/order?page=' + page + '&status=' + status + '&size=' + size + '&regexPattern=' + regexPattern, this.buildHeaders());
    } else {
      return this._http.get(this.baseURL + '/order/client/' + localStorage.getItem('clientId') + '?' + 'page=' + page + '&status=' + status + '&size=' + size + '&regexPattern=' + regexPattern, this.buildHeaders());
    }
  }

  getOrder(orderId) {
    console.log('Inside get all orders');
    return this._http.get(this.baseURL + '/order/' + orderId, this.buildHeaders());
  }

  createOrder(orderData, clientId) {
    if (orderData.id === '') {
      return this._http.post(this.baseURL + '/order/client/' + clientId , orderData, this.buildHeaders());
    } else {
      return this._http.put(this.baseURL + '/order/' + orderData.id+'/update', orderData, this.buildHeaders());
    }
  }

  createProvision(provisionData, orderId) {
    return this._http.post(this.baseURL + '/order/' + orderId + '/provision/', provisionData, this.buildHeaders());
  }

  cancelOrder(orderId, orderComment) {
    return this._http.put(this.baseURL + '/order/' + orderId + '/cancel', orderComment, this.buildHeaders());
  }

  /* Construct a common header */
  private buildHeaders(): any {
    const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
    return new RequestOptions({ headers: headers });
  }
}
